<template>
  <div class="container py-10">
    <div v-if="computedSubmissionDetails" class="flex flex-wrap -mx-10">
      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Project Information</h2>
        <edit-project-info v-if="computedSubmissionDetails.revisedProject" class="mb-3" :project.sync="computedSubmissionDetails.revisedProject" />
      </div>
      <div class="mb-16 w-full lg:w-1/2 px-10" />

      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Contractor - Organization Information</h2>
        <edit-organization-info v-if="computedSubmissionDetails.revisedContractor" class="mb-3" :organization.sync="computedSubmissionDetails.revisedContractor" />
      </div>

      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Contractor - Contact Information</h2>
        <edit-contact-info v-if="computedSubmissionDetails.revisedContractorContact" class="mb-3" :contact.sync="computedSubmissionDetails.revisedContractorContact" />
      </div>

      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Woodworker - Organization Information</h2>
        <edit-organization-info v-if="computedSubmissionDetails.revisedWoodworker" class="mb-3" :organization.sync="computedSubmissionDetails.revisedWoodworker" />
      </div>

      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Woodworker - Contact Information</h2>
        <edit-contact-info v-if="computedSubmissionDetails.revisedWoodworker" class="mb-3" :contact.sync="computedSubmissionDetails.revisedWoodworker" />
      </div>
    </div>
  </div>
</template>

<script>
  import EditOrganizationInfo from '@resources/scripts/patterns/formPatterns/EditOrganizationInfo.vue';
  import EditContactInfo from '@resources/scripts/patterns/formPatterns/EditContactInfo.vue';
  import EditProjectInfo from '@resources/scripts/patterns/formPatterns/EditProjectInfo.vue';

  export default {
    components: {
      EditOrganizationInfo,
      EditContactInfo,
      EditProjectInfo,
    },

    props: {
      submissionDetails: {
        type: Object,
        default: () => ({}),
      },
    },

    computed: {
      computedSubmissionDetails: {
        get() {
          return this.submissionDetails;
        },
        set(value) {
          this.$emit('submissionDetails:update', value);
        },
      },
    },
  };
</script>